export const FacilityType = {
  TVS: 'TVS',
  CNV: 'CNV',
  PT: 'PT'
}

export const translateFacilityType = (facilityType) => {
  switch (facilityType) {
    case FacilityType.TVS:
      return '直営施設'
    case FacilityType.CNV:
      return 'HCV施設'
    case FacilityType.PT:
      return 'ポイント提携施設'
    default:
      return ''
  }
}

export const getOrderOfFacilityType = (facilityType) => {
  switch (facilityType) {
    case FacilityType.TVS:
      return 1
    case FacilityType.CNV:
      return 2
    case FacilityType.PT:
      return 3
    default:
      return 4
  }
}

// Sale-ended facilities are display-grouped separately from their facility type.
export const SALE_ENDED_GROUP = 'SALE_ENDED'
export const SALE_ENDED_GROUP_ORDER = 99
export const SALE_ENDED_GROUP_NAME = '営業終了施設'

// today: 'YYYY-MM-DD' (from $today()). Sale has ended when stopSaleDate is set and <= today.
export const isFacilitySaleEnded = (facility, today) =>
  Boolean(facility.stopSaleDate) && facility.stopSaleDate <= today

export const facilityGroupKey = (facility, today) =>
  isFacilitySaleEnded(facility, today) ? SALE_ENDED_GROUP : facility.type

export const facilityGroupOrder = (facility, today) =>
  isFacilitySaleEnded(facility, today) ? SALE_ENDED_GROUP_ORDER : getOrderOfFacilityType(facility.type)

export const facilityGroupName = (facility, today) =>
  isFacilitySaleEnded(facility, today) ? SALE_ENDED_GROUP_NAME : translateFacilityType(facility.type)
